import { Box, useToast, VStack } from '@chakra-ui/react';
import { useEffect } from 'react';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { Text } from '../../../components/atoms/Text';
import { Button } from '../../../components/atoms/Button';
import { useTheme } from '../../../contexts/ThemeProvider';
import { MyAppointment } from '../../../service/telemedicine/api';
import { parseDateKey } from '../utils/date';

interface OpenAppointmentCardProps {
  appointment: MyAppointment;
  isCancelling: boolean;
  cancelError: string;
  onCancel: () => void;
}

/** Consulta já agendada do usuário: enquanto ela existir, não é possível marcar outra. */
export function OpenAppointmentCard({ appointment, isCancelling, cancelError, onCancel }: OpenAppointmentCardProps) {
  const { colors } = useTheme();
  const toast = useToast();

  useEffect(() => {
    if (!cancelError) return;
    toast({ title: cancelError, status: 'error', duration: 9000, isClosable: true });
  }, [cancelError, toast]);

  return (
    <VStack align={'stretch'} spacing={4} width={'100%'}>
      <Text fontSize={'14px'} color={'#4A5568'}>
        Você já tem um atendimento agendado. Não é possível marcar um novo enquanto ele estiver em aberto.
      </Text>

      <Box border={'1px solid #E2E8F0'} borderRadius={'16px'} padding={'16px'} backgroundColor={'#FAFAF9'}>
        <Text fontSize={'14px'} fontWeight={700} marginBottom={2}>
          Seu atendimento
        </Text>
        <VStack align={'stretch'} spacing={1}>
          <Text fontSize={'13px'} color={'#4A5568'}>
            Especialidade: <strong>Clínico Geral</strong>
          </Text>
          <Text fontSize={'13px'} color={'#4A5568'}>
            Data: <strong>{format(parseDateKey(appointment.date), "dd 'de' MMMM 'de' yyyy", { locale: ptBR })}</strong>
          </Text>
          <Text fontSize={'13px'} color={'#4A5568'}>
            Horário: <strong>{appointment.time}</strong>
          </Text>
          <Text fontSize={'13px'} color={'#4A5568'}>
            Status: <strong>{appointment.status}</strong>
          </Text>
        </VStack>

        <Box marginTop={3} padding={'10px 12px'} borderRadius={'8px'} borderLeft={'3px solid'} borderColor={colors.primaryColor} backgroundColor={'#FFFFFF'}>
          <Text fontSize={'13px'} color={'#4A5568'}>
            O link para entrar na sala será enviado para o seu e-mail quando o atendimento estiver prestes a começar.
          </Text>
        </Box>
      </Box>

      <Button
        variant={'outline'}
        backgroundColor={'transparent'}
        color={'#E53E3E'}
        border={'1px solid #E53E3E'}
        _hover={{ backgroundColor: '#FFF5F5' }}
        isLoading={isCancelling}
        onClick={onCancel}
      >
        Cancelar agendamento
      </Button>
    </VStack>
  );
}
